import axiosInstance from './axiosInstance';
import { BASE_URL } from '../Constants';
export const fetchWeeklyReports = async (employeeId, year, weekStartDate, weekEndDate) => {
    try {
        const response = await axiosInstance.get(`${BASE_URL}/weeklyReports/byWeek`, {
            params: {
                employeeId,
                year,
                weekStartDate,
                weekEndDate,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching weekly reports:', error);
        throw error;
    }
};

export const createWeeklyReport = async (reportData) => {
    try {
        const response = await axiosInstance.post(`${BASE_URL}/weeklyReports`, reportData);
        return response.data;
    } catch (error) {
        console.error('Error creating weekly report:', error);
        throw error;
    }
};

export const updateWeeklyReport = async (reportData) => {
    try {
        const response = await axiosInstance.put(`${BASE_URL}/weeklyReports`, reportData);
        return response.data;
    } catch (error) {
        console.error('Error updating weekly report:', error);
        throw error;
    }
};

export const sendWeeklyReportSubmissionEmail = async (data) => {
    try {
        const response = await axiosInstance.post(`${BASE_URL}/sendEmail/weeklyReportSubmission`, data);
        return response.data;
    } catch (error) {
        console.error('Error sending weekly report submission email:', error);
        throw error;
    }
};